export default __webpack_public_path__ + "static/media/FI.f466efc0.svg";